<template>
  <span>
    <basic-booth v-if="user_data.sponsor_type == 3" />
    <gold-booth v-if="user_data.sponsor_type == 4" />
    <diamond-booth v-if="user_data.sponsor_type == 6" />
  </span>
</template>
<script>
import BasicBooth from "@/components/booth/BasicBooth";
import GoldBooth from "@/components/booth/GoldBooth";
import DiamondBooth from "@/components/booth/DiamondBooth";
import { mapMutations, mapState } from "vuex";
export default {
  name: "MainImage",
  components: {
    BasicBooth,
    GoldBooth,
    DiamondBooth
  },
  data(){
    return {
      user_data : {
        sponsor_type : ''
      }
    }
  },
  computed : {
    ...mapState("utils", ["isBoothPreview"]),
  },
  methods : {
    ...mapMutations("utils", ["setUtilData"]),
  },
  mounted(){
    if(this.$route.params.type=='view'){
      this.setUtilData({
        key : 'isBoothPreview',
        data : true
      })
    }
    this.user_data = JSON.parse(localStorage.getItem("vendor_data"));
  }
}
</script>
<style>
.cursor_edit {
  cursor: url('/edit-20.png'), auto;
}
</style>